module.exports = __webpack_public_path__ + "img/schema_recheche_realisee_par_nos_soins.a67df63c.jpg";